import _ from 'lodash'

const sumTwoDecimalPlaces = vals => _.round(_(vals).compact().sum(), 2)
const meanTwoDecimalPlaces = vals => Math.round(_.mean(_.map(_.compact(vals), val => parseFloat(val))) * 100) / 100

export { sumTwoDecimalPlaces, meanTwoDecimalPlaces }
